/** Presentation of the existing authoritative Lv10 / three defeated ghosts rule. */
export function classAdvancementView(level:number,defeats:number,accepted:boolean):{canAccept:boolean;hint:string}{
 const count=Math.max(0,Math.min(3,Math.floor(defeats)));
 if(level<10)return {canAccept:false,hint:`ชาวบ้าน Lv.${level} · ต้องถึง Lv.10 และปราบผี 3 ตัวก่อนเลือกสาย (ตอนนี้ ${count} / 3)`};
 if(count<3)return {canAccept:false,hint:`Lv.${level} ถึงเกณฑ์แล้ว · ฝึกปราบผี ${count} / 3 ตัว แล้วกลับหาครูฝึกอาชีพในเมือง`};
 if(accepted)return {canAccept:false,hint:'ผ่านการฝึกแล้ว · เลือกอาชีพหนึ่งสายกับครูฝึก จะได้รับอาวุธ ชุด และสกิลแรก'};
 return {canAccept:true,hint:`Lv.${level} · ปราบผีครบ 3 / 3 · รับภารกิจจากครูฝึกอาชีพในเมือง แล้วเลือกสายได้`};
}
